import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=320d3d42&scoped=true"
import script from "./Discover.vue?vue&type=script&lang=js"
export * from "./Discover.vue?vue&type=script&lang=js"
import style0 from "./Discover.vue?vue&type=style&index=0&id=320d3d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d3d42",
  null
  
)

export default component.exports